import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    AppBlockPort,
} from '@appblocks/codegeneration/types';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';


export default class NodeGroup extends BaseNode {
    constructor() {
        super();
        this.name = 'Tab';
        this.id = 'node_group';
        this.linkedFeature = 'general';
    }

    getInputs(): AppBlockPort[] {
        const project: ProjectConfiguration = this.project;
        const groupId = this.getID();

        for (let i = 0; i < project.features.length; i++) {
            const feature = project.features[i];
            if (feature.getSettingValue('GROUP') === groupId) {
                if (feature.id === 'node_group_input') {
                    const name = feature.getSettingValue('DISPLAY_NAME');
                    const links = project.getNodeLinks(feature as BaseNode, 'output');
                    if (links.length > 0) {
                        return [
                            {
                                name,
                                portId: 'input',
                                params: [],
                            },
                        ];
                    }
                }
            }
        }
        return [];
    }

    getOutputs(): AppBlockPort[] {
        const project: ProjectConfiguration = this.project;
        const groupId = this.getID();

        this.outputs = [];
        let outputCount = 0;
        for (let i = 0; i < project.features.length; i++) {
            const feature = project.features[i];
            if (feature.getSettingValue('GROUP') === groupId) {
                if (feature.id === 'node_group_output') {
                    const name = feature.getSettingValue('DISPLAY_NAME');
                    const links = project.getNodeLinks(feature as BaseNode, 'input');
                    if (links.length > 0) {
                        this.outputs.push({
                            name,
                            portId: `output${outputCount}`,
                            params: [],
                        });
                        outputCount++;
                    }
                }
            }
        }
        return this.outputs;
    }

    getName(): string {
        const displayName = this.getSettingValue('DISPLAY_NAME');
        if (displayName !== '') {
            return displayName;
        }
        return this.name;
    }

    validate(): ValidationMessage[] {
        const messages: ValidationMessage[] = [];
        const project: ProjectConfiguration = this.project;
        const groupId = this.getID();


        return messages;
    }

    getInputPort(): any {
        const project: ProjectConfiguration = this.project;
        const groupId = this.getID();
        for (let i = 0; i < project.features.length; i++) {
            const feature = project.features[i];
            if (feature.id === 'node_group_input' && feature.getSettingValue('GROUP') === groupId) {
                const links = project.getNodeLinks(feature as BaseNode, 'output');
                if (links.length > 0) {
                    const link = links[0];
                    const node: BaseNode = project.getFeature(link.getSettingValue('TARGET_FEATURE')) as BaseNode;
                    const nodePort = node.getPort(link.getSettingValue('TARGET_PORT'));
                    return {
                        feature: node,
                        port: nodePort,
                    };
                }
            }
        }
        return undefined;
    }

    getOutputPorts(): any[] {
        const project: ProjectConfiguration = this.project;
        const groupId = this.getID();
        const outputs = [];
        for (let i = 0; i < project.features.length; i++) {
            const feature = project.features[i];
            if (feature.id === 'node_group_output' && feature.getSettingValue('GROUP') === groupId) {
                const links = project.getNodeLinks(feature as BaseNode, 'input');
                if (links.length > 0) {
                    const link = links[0];
                    const node: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
                    const nodePort = node.getPort(link.getSettingValue('SOURCE_PORT'));
                    outputs.push({
                        feature: node,
                        port: nodePort,
                    });
                }
            }
        }
        return outputs;
    }
}
